<header id="page-topbar">
<div class="navbar-header">

    <!-- Left -->
    <div class="header-left">

        <div class="navbar-brand-box bg-white">
            <a href="javascript:void(0)"
               (click)="requestSent(deleteConsumerData)"
               class="logo logo-light">
                <img *ngIf="imageUrl"
                     [src]="imageUrl"
                     class="main-logo"
                     alt="logo">
 <!--  -->
                <img *ngIf="!imageUrl"
                     src="../../../assets/images/logo_main.png"
                     class="main-logo"
                     alt="logo">

            </a>
        </div>

        <!-- Search -->
        <div class="header-search">
            <i class="bx bx-search"></i>

            <input
                type="text"
                placeholder="Search Fleet">
        </div>

    </div>

    <!-- Right -->
    <div class="header-right">

        <!-- <button class="icon-btn">
            <i class="bx bx-bell"></i>
        </button>

        <button class="icon-btn">
            <i class="bx bx-cog"></i>
        </button> -->

        <div class="dropdown profile-dropdown"
             ngbDropdown>

            <button
                ngbDropdownToggle
                class="profile-btn"
                id="page-header-user-dropdown">

                <div class="user-details">

                    <h6>{{loginUser?.name}}</h6>

                    <span>FLEET ADMIN</span>

                </div>

               <span class="topbar-box">{{
                  loginUser?.name.split(' ')[0].charAt(0) | uppercase }}{{ loginUser?.name.split(' ')[1]?.charAt(0) |
                  uppercase }}</span>

            </button>

            <div
                ngbDropdownMenu
                class="dropdown-menu dropdown-menu-end">

                <a class="dropdown-item"
                   (click)="support()"  style="cursor: pointer;">
                    <i class="bx bx-wrench me-2"></i>
                    Support
                </a>

                <div class="dropdown-divider"></div>

                <a class="dropdown-item text-danger"
                   (click)="logout()" style="cursor: pointer;">
                    <i class="bx bx-power-off me-2"></i>
                    Logout
                </a>

            </div>

        </div>

    </div>
   <div class="mobile-actions d-lg-none" ngbDropdown>

        <button class="mobile-menu-btn" ngbDropdownToggle>
            <i class="bx bx-menu"></i>
        </button>

        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end mobile-dropdown">
        <a routerLink="/adlp/consentreequest/consent-dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="dropdown-item"> <i class="bx bx-check-square"></i> Consent Request</a>  <hr>
        <a routerLink="/adlp/report/inactivity-report" routerLinkActive="active" class="dropdown-item"> <i class="bx bx-building"></i> VIN Inactivity Report </a><hr>
        <!-- <a routerLink="/adlp/support" routerLinkActive="active" class="dropdown-item"> <i class="bx bx-help-circle"></i> Help</a><hr> -->
        <a class="dropdown-item"><h6 style="color: #fa751a;font-size: 13px;font-weight: 500;"><i class="bx bx-user-circle"></i> {{loginUser?.name}}
                ({{loginUser?.email}})</h6></a><hr>
        <a class="dropdown-item text-danger" (click)="logout()">
            
            <i class="bx bx-signout"></i><span style="text-align: center;">Logout</span>
        </a>

        </div>

    </div>


</div>
<div class="top-menu d-none d-lg-flex">
    <a routerLink="/adlp/consentreequest/consent-dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"> <i class="bx bx-check-square"></i> Consent Request</a>
    <a routerLink="/adlp/report/inactivity-report" routerLinkActive="active"> <i class="bx bx-building"></i> VIN Inactivity Report </a>
<!-- 
    <span class="menu-spacer"></span>

    <a (click)="support()">
        <i class="bx bx-help-circle"></i>
        Help
    </a> -->

</div>
</header>

<ng-template #deleteConsumerData let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Upload Logo</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal();modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="image-upload">
      <div class="preview-container" *ngIf="preview">
        <img alt="image upload" [src]="preview" class="img1">
      </div>
      <input type="file" (change)="onFileSelected($event)" accept="image/*" style="margin-left: 28px; margin-top: 12px;">
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-login-new" [disabled]="!selectedImage" (click)="modal.close('Save click');changeLogo()">Uplaod Logo</button>
    <!-- <button type="reset" class="btn btn-light m-1" (click)="closeModal();modal.close('Close click')">No</button> -->
  </div>
</ng-template>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-circus" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
  </ngx-spinner>